import { css, LitElement, html } from 'lit-element';
import { ScopedElementsMixin } from '@open-wc/scoped-elements';
import { unsafeSVG } from 'lit-html/directives/unsafe-svg';

var css_248z = css`/* Grid */
*,
*::before,
*::after {
  box-sizing: border-box;
}

.m-1 {
  margin: 8px !important;
}

.ml-1 {
  margin-left: 8px !important;
}

.d-flex {
  display: flex !important;
}

.align-items-center {
  -ms-flex-align: center !important;
  align-items: center !important;
}

.justify-content-center {
  -ms-flex-pack: center !important;
  justify-content: center !important;
}

@media all and (-ms-high-contrast: none) {
  *::-ms-backdrop, .ie-loader-animation {
    animation: ie-spinner-transform 1s linear infinite;
  }
}
@keyframes ie-spinner-transform {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
.spinner-overlay {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  position: absolute;
}

.spinner-overlay:after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.5;
  background: #f9f9f9;
}

.spinner-icon, .spinner-text {
  z-index: 2;
}`;

const spinner = `<svg class="loading-spinner" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
<style>
    @keyframes yellow-circle {
        0% {
            stroke-dashoffset: 141.3;
            transform: rotateZ(-108deg);
        }

        50% {
            stroke-dashoffset: 113.04;
            transform: rotateZ(39.6deg);
        }

        100% {
            stroke-dashoffset: 141.3;
            transform: rotateZ(252deg);
        }
    }

    @keyframes light-green-circle {
        0% {
            stroke-dashoffset: 113.04;
            transform: rotateZ(-140.4deg);
        }

        50% {
            stroke-dashoffset: 51.81;
            transform: rotateZ(1.8deg);
        }

        100% {
            stroke-dashoffset: 113.04;
            transform: rotateZ(219.6deg);
        }
    }

    .loading-spinner {
        width: 100%;
        height: 100%;
        stroke-linecap: round;
        stroke-width: 6;
        fill: none;
    }

    .loader-circle {
        stroke-dasharray: 157;
        transform-origin: center;
    }

    .loader-circle-yellow {
        stroke: #ffd200;
        stroke-dashoffset: 141.3;
        transform: rotateZ(-108deg);
        animation: yellow-circle 1s linear infinite;
    }

    .loader-circle-light-green {
        stroke-dashoffset: 113.04;
        stroke: #86d1cd;
        transform: rotateZ(-140.4deg);
        animation: light-green-circle 1s linear infinite;
    }

    .loader-circle-dark-green {
        stroke: #37aba1;
    }
</style>
    <circle class="loader-circle loader-circle-dark-green" cx="28" cy="28" r="25"></circle>
    <!-- transform is ie11 fallback -->
    <circle class="loader-circle loader-circle-light-green" cx="28" cy="28" r="25" transform='rotate(-140.4 28 28)'></circle>
    <circle class="loader-circle loader-circle-yellow" cx="28" cy="28" r="25" transform='rotate(-108 28 28)'></circle>
</svg>`;

class AabSpinner extends ScopedElementsMixin(LitElement) {
  constructor() {
    super();
    // Initialize LitElement properties here
    this.svg = spinner;
    this.size = 5;
    this.hideOverlay = false;
  }

  static get properties() {
    return {
      // LitElement properties here
      text: { type: String },
      size: { type: Number },
      hideOverlay: { type: Boolean, attribute: 'hide-overlay' },
    };
  }

  static get styles() {
    return [css_248z];
  }

  updated() {
    this.shadowRoot.querySelector('.spinner-icon')
      .setAttribute('style', `height: ${this.size * 8}px; width:${this.size * 8}px;`);
  }

  render() {
    return html`
        <span class="d-flex justify-content-center align-items-center  ${this.hideOverlay ? 'm-1' : 'spinner-overlay'}">
            <div class="spinner-icon ie-loader-animation">
                ${unsafeSVG(this.svg)}
            </div>
            <span class="spinner-text ml-1">
                ${this.text}
            </span>
        </span>`;
  }
}

export { AabSpinner as default };
